import * as z from "zod/v4";

export const deleteEcwidIntegration = {
  name: "deleteEcwidIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
